import React from 'react';
import ReactApexChart from 'react-apexcharts';
import axios from 'axios';

class LineChart extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      series: [{
        name: 'User Counts',
        data: []
      }],
      options: {
        chart: {
          height: 350,
          type: 'line',
          zoom: {
            enabled: false
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'straight',
          width: 3,
          colors: ['#1B1462']
        },
       
        grid: {
          row: {
            colors: ['#f3f3f3', 'transparent'],
            opacity: 0.5
          },
        },
        xaxis: {
          categories: [],
        },
        markers: {
          size: 6,
          colors: ['#1B1462'],
          strokeColors: '#1B1462',
          strokeWidth: 2,
          hover: {
            size: 8
          }
        }
      }
    };
  }

  componentDidMount() {
    this.fetchLineChartData();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.selectedMonth !== this.props.selectedMonth) {
      this.fetchLineChartData();
    }
  }

  fetchLineChartData = async () => {
    try {
      let response;
      if (this.props.selectedMonth) {
        response = await axios.post('https://zingapi.beeinnovations.com/boxoffice_app/circle_subscription.php', {
          month: this.props.selectedMonth
        });
      } else {
        response = await axios.get('https://zingapi.beeinnovations.com/boxoffice_app/circle_subscription.php');
      }

      const data = response.data.circle_subscription;
      const categories = data.map(item => item.circle);
      const seriesData = data.map(item => item.count);

      this.setState({
        series: [{
          name: 'User Counts',
          data: seriesData
        }],
        options: {
          ...this.state.options,
          xaxis: {
            categories: categories
          }
        }
      });
    } catch (error) {
      console.error('Error fetching line chart data:', error);
    }
  };

  render() {
    return (
      <div id="line-chart">
        <ReactApexChart options={this.state.options} series={this.state.series} type="line" height={350} />
      </div>
    );
  }
}

export default LineChart;
